import React, { useEffect } from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { getDateUptoDate } from "../../../service/date_service/date_service";
import { textCase } from "../../../service/ui/UI";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import BubbleImage from "../widget/chat_bubbles/BubbleImage";
import BubbleAudio from "../widget/chat_bubbles/BubbleAudio";
import BubbleVideo from "../widget/chat_bubbles/BubbleVideo";
import BubbleDocument from "../widget/chat_bubbles/BubbleDocument";
import NoData from "../../../widget/common/ui/NoData";
import BubbleLocation from "../widget/chat_bubbles/BubbleLocation";
import BubbleLink from "../widget/chat_bubbles/BubbleLink";
import { ChatMediaContextImport } from "../../../provider/chats/chats/chat_media/ChatMediaContextProvider";
import { Position } from "../../../widget/common/ui/Stack";
import { CheckBoxRound } from "../../../widget/common/ui/Checkbox";
import { ButtonDouble } from "../../../widget/common/form/Button";
import { useDispatch } from "react-redux";
import {
  mediaDeleteChooseAction,
  setForwardMediaList,
} from "../../../libraries/state_reducers/chats/ChatsReducer";

const ChatMediaContent: React.FC<{ viewType: "sidebar" | "modal" }> = ({
  viewType,
}) => {
  const {
    chatSelected,
    handleClickTab,
    selectedTab,
    tabList,
    medialListChucked,

    mediaIdsSelected,
    longPressStatus,
    handleClickMedia,
    handlePressStart,
    handlePressEnd,
    clearLongPress,
    handleDelete,
    handleSend,
  } = ChatMediaContextImport();

  const dispatch = useDispatch();

  const deviceTab = (
    tabId: "2" | "3" | "4" | "6" | "9" | "5",
    title: string
  ): JSX.Element => {
    return (
      <div
        className={`px-2 d-inline-block ${
          selectedTab === tabId ? "font-gotham-bold color-theme-sublabel" : ""
        }`}
        role="button"
        onClick={() => handleClickTab(tabId)}
      >
        {AppTranslation.text(title)}
      </div>
    );
  };

  const showMediaList = (): JSX.Element => {
    return (
      <div
        className={`media-list-view-${viewType} px-4 ${
          longPressStatus ? "media-seletction-multiple" : ""
        } ${
          Object.entries(medialListChucked![selectedTab] ?? {}).length === 0
            ? "h-100"
            : ""
        }`}
      >
        {selectedTab === "2" ? (
          <>
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <div
                  key={date}
                  className="py-2 font-size-14_15 font-gotham-bold color-theme-sublabel"
                >
                  <div className=" pb-2">
                    {textCase(getDateUptoDate(new Date(date)))}
                  </div>
                  <div className="media-grid-list">
                    {group.map((media, key) => (
                      <div
                        key={key}
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleImage
                          key={key}
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                          imageSize="100%"
                        />
                        {longPressStatus && (
                          <Position bottom={0} className="w-100 d-center">
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </>
        ) : selectedTab === "3" ? (
          <Listing className="media-grid-audio">
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <>
                  {group.map((media, key) => (
                    <ListItem key={key}>
                      <div
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleAudio
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                          audioRangeWidth="100%"
                        />
                        {longPressStatus && (
                          <Position
                            right={0}
                            top={0}
                            className="d-center h-100"
                          >
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    </ListItem>
                  ))}
                </>
              )
            )}
          </Listing>
        ) : selectedTab === "4" ? (
          <>
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <div
                  key={date}
                  className="py-2 font-size-14_15 font-gotham-bold color-theme-sublabel"
                >
                  <div className=" pb-2">
                    {textCase(getDateUptoDate(new Date(date)))}
                  </div>
                  <div className="media-grid-list">
                    {group.map((media, key) => (
                      <div
                        key={key}
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleVideo
                          key={key}
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                          videoSize="100%"
                        />
                        {longPressStatus && (
                          <Position bottom={0} className="w-100 d-center">
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </>
        ) : selectedTab === "6" ? (
          <Listing className="media-grid-documents">
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <>
                  {group.map((media, key) => (
                    <ListItem key={key}>
                      <div
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleDocument
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                          showDocDate={getDateUptoDate(
                            new Date(media.create_date!)
                          )}
                          fromMedia={true}
                        />
                        {longPressStatus && (
                          <Position
                            right={0}
                            top={0}
                            className="d-center h-100"
                          >
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    </ListItem>
                  ))}
                </>
              )
            )}
          </Listing>
        ) : selectedTab === "9" ? (
          <Listing className="media-grid-documents">
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <>
                  {group.map((media, key) => (
                    <ListItem key={key}>
                      <div
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleLink
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                          linkIsMedia={true}
                        />
                        {longPressStatus && (
                          <Position
                            right={0}
                            top={0}
                            className="d-center h-100"
                          >
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    </ListItem>
                  ))}
                </>
              )
            )}
          </Listing>
        ) : selectedTab === "5" ? (
          <>
            {Object.entries(medialListChucked![selectedTab] ?? {}).map(
              ([date, group]) => (
                <div
                  key={date}
                  className="py-2 font-size-14_15 font-gotham-bold color-theme-sublabel"
                >
                  <div className=" pb-2">
                    {textCase(getDateUptoDate(new Date(date)))}
                  </div>
                  <div className="media-grid-list media-grid-location">
                    {group.map((media, key) => (
                      <div
                        key={key}
                        className="position-relative"
                        role={longPressStatus ? "button" : ""}
                        onClick={() => handleClickMedia(media.message_id!)}
                        onMouseDown={() => handlePressStart(media.message_id!)}
                        onMouseUp={handlePressEnd}
                        onMouseLeave={handlePressEnd}
                        onTouchStart={() => handlePressStart(media.message_id!)}
                        onTouchEnd={handlePressEnd}
                      >
                        <BubbleLocation
                          key={key}
                          messageType={media?.message_type!}
                          message={media.decripted_mesage!}
                        />
                        {longPressStatus && (
                          <Position bottom={0} className="w-100 d-center">
                            <CheckBoxRound
                              status={mediaIdsSelected.includes(
                                media.message_id!
                              )}
                            />
                          </Position>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </>
        ) : (
          <></>
        )}

        {Object.keys(medialListChucked![selectedTab] ?? {}).length === 0 && (
          <Center className="h-100">
            <NoData />
          </Center>
        )}
      </div>
    );
  };

  const chatMediaContentBody = (): JSX.Element => {
    return (
      <>
        {chatSelected != null && medialListChucked != null ? (
          <>
            <div className="h-100">
              {viewType === "modal" ? (
                <div className="chat-media-list h-100">
                  <div
                    className={`bgcolor-primary w-100 overflow-auto font-size-16_17 color-theme-font pb-3 text-center `}
                  >
                    <div className=" media-tab mx-auto" style={{ width: 500 }}>
                      {deviceTab("2", "images")}
                      {deviceTab("3", "audio")}
                      {deviceTab("4", "video")}
                      {deviceTab("6", "documents")}
                      {deviceTab("9", "links")}
                      {deviceTab("5", "location")}
                    </div>
                  </div>
                  <div
                    className={`py-4  ${
                      viewType === "modal" ? "h-100 overflow-auto" : ""
                    }`}
                  >
                    {showMediaList()}
                  </div>
                </div>
              ) : (
                <div className="border-bottom pt-4 font-size-16_17 color-theme-label font-gotham-medium ">
                  {tabList.map((id) => (
                    <div key={id}>
                      <div
                        className={`py-2 px-4 border-top ${
                          id === selectedTab ? "font-gotham-bold" : ""
                        }`}
                        role="button"
                        onClick={() => handleClickTab(id)}
                      >
                        {AppTranslation.text(
                          id === "2"
                            ? "images"
                            : id === "3"
                            ? "audio"
                            : id === "4"
                            ? "video"
                            : id === "6"
                            ? "documents"
                            : id === "9"
                            ? "links"
                            : "location"
                        )}
                      </div>
                      {id === selectedTab && (
                        <div className=" pb-3 font-gotham-book font-size-16_17">
                          {showMediaList()}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {viewType === "sidebar" && longPressStatus && (
              <div className="px-4">
                <ButtonDouble
                  height={45}
                  title1="delete"
                  title2="forward"
                  handleClick1={() => handleDelete()}
                  handleClick2={() => handleSend()}
                />
              </div>
            )}
          </>
        ) : (
          <Center className="h-100">{Loader.normal()}</Center>
        )}
      </>
    );
  };

  useEffect(() => {
    return () => {
      console.log("close media");
      clearLongPress();
      dispatch(mediaDeleteChooseAction(null));
      dispatch(setForwardMediaList(null));
    };
    // eslint-disable-next-line
  }, []);

  return viewType === "sidebar" ? (
    chatMediaContentBody()
  ) : (
    <div className="sidebar-body h-100">{chatMediaContentBody()}</div>
  );
};

export default ChatMediaContent;
